import React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import clsx from "clsx";
import { HiOutlineMinus, HiOutlinePlus } from "react-icons/hi2";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={clsx("[&:not(:last-child)]:border-b", className)} {...props} />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger> & { variant?: "normal" | "filter" }
>(({ className, children, variant = "normal", ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={clsx(
        "group flex flex-1 items-center justify-between rounded-sm outline-none transition-all focus-visible:ring-4 focus-visible:ring-focus-input",
        variant === "normal" && "py-3 font-medium text-primary",
        variant === "filter" && "py-3 text-sm text-tertiary",
        className,
      )}
      {...props}
    >
      {children}
      <HiOutlinePlus
        className={clsx("h-4 w-4 shrink-0 transition-transform duration-200", "group-data-[state=open]:hidden")}
      />
      <HiOutlineMinus
        className={clsx("h-4 w-4 shrink-0 transition-transform duration-200", "group-data-[state=closed]:hidden")}
      />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content ref={ref} className="group text-sm text-quaternary transition-all" {...props}>
    <div className={clsx("pb-3 pt-0", className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
